// import Cookies from "js-cookie";

// const CATEGORY_COOKIE = "sandesh_categories";

// export const addCategoryToCookie = (category) => {
//   if (!category) return;

//   let existing = Cookies.get(CATEGORY_COOKIE);
//   let categories = existing ? JSON.parse(existing) : [];

//   if (!categories.includes(category)) {
//     categories.push(category);
//   }

//   Cookies.set(CATEGORY_COOKIE, JSON.stringify(categories), {
//     expires: 30,
//     path: "/",
//     secure: true,
//     sameSite: "Strict",
//   });

//   console.log("Updated Categories:", categories);
// };

// export const getCategoriesFromCookie = () => {
//   const data = Cookies.get(CATEGORY_COOKIE);
//   return data ? JSON.parse(data) : [];
// };
// import Cookies from "js-cookie";

// const CATEGORY_COOKIE = "sandesh_categories";

// export const addCategoryToCookie = (category) => {
//   if (!category) return;

//   let existing = Cookies.get(CATEGORY_COOKIE);
//   let categories = existing ? JSON.parse(existing) : [];

//   // Remove if already exists
//   categories = categories.filter((cat) => cat !== category);

//   // Add to beginning (most recent first)
//   categories.unshift(category);

//   // Optional: limit to last 10 categories
//   if (categories.length > 10) {
//     categories = categories.slice(0, 10);
//   }

//   Cookies.set(CATEGORY_COOKIE, JSON.stringify(categories), {
//     expires: 30,
//     path: "/",
//     secure: true,
//     sameSite: "Strict",
//   });

//   console.log("Updated Categories:", categories);
// };

// export const getCategoriesFromCookie = () => {
//   const data = Cookies.get(CATEGORY_COOKIE);
//   return data ? JSON.parse(data) : [];
// };

import Cookies from "js-cookie";

const CATEGORY_COOKIE = "sandesh_categories";

// Categories that should NOT be stored
const EXCLUDED_CATEGORIES = ["for-you"];

export const addCategoryToCookie = (category) => {
  if (!category) return;

  // ❌ Do not store excluded categories
  if (EXCLUDED_CATEGORIES.includes(category.toLowerCase())) {
    return;
  }

  let existing = Cookies.get(CATEGORY_COOKIE);
  let categories = existing ? JSON.parse(existing) : [];

  // Remove if already exists
  categories = categories.filter((cat) => cat !== category);

  // Add to beginning (most recent first)
  categories.unshift(category);

  // Optional: limit to last 10 categories
  if (categories) {
    categories = categories;
  }

  Cookies.set(CATEGORY_COOKIE, JSON.stringify(categories), {
    expires: 30,
    path: "/",
    secure: true,
    sameSite: "Strict",
  });

};

export const setCategoriesToCookie = (categories) => {
  Cookies.set(CATEGORY_COOKIE, JSON.stringify(categories), {
    expires: 30,
    path: "/",
    secure: true,
    sameSite: "Strict",
  });
};

export const getCategoriesFromCookie = () => {
  const data = Cookies.get(CATEGORY_COOKIE);
  return data ? JSON.parse(data) : [];
};
